import { NgModule } from '@angular/core';
import { SanitizeHtmlService } from './sanitizehtml.pie';


@NgModule({
    imports: [

    ],

    declarations: [
        SanitizeHtmlService
    ],

    exports: [
        SanitizeHtmlService
    ],

    providers: [
        SanitizeHtmlService
    ]
})
export class SanitizeHtmlServiceModule { }